// import React from "react";
// import "./RecommendationCard.css";
// function RecommendationCard({
//   recommendationCardTitle,
//   recommendation,
//   currentPage,
//   totalPages,
// }) {
//   return (
//     <div className="card shadow-sm agent-improvement-recommendation-card-container">
//       <div className="Agentcard-body">
//         <h5 className="card-title agent-improvement-recommendation-card-title mb-4">
//           {recommendationCardTitle} Improvement Recommendation {currentPage}/
//           {totalPages}
//         </h5>

//         <div className="mb-4">
//           <h6 className="agent-improvement-recommendation-labels">
//             Opportunity:
//           </h6>
//           <p className="agent-improvement-recommendation-comments"
//            dangerouslySetInnerHTML={{ __html: recommendation?.opportunity }}
//           >
//           </p>
//         </div>

//         <div className="mb-4">
//           <h6 className="agent-improvement-recommendation-labels">
//             Recommendation:
//           </h6>
//           <p
//             className="agent-improvement-recommendation-comments"
//             dangerouslySetInnerHTML={{ __html: recommendation?.recommendation }}
//           ></p>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default RecommendationCard;

import React from "react";
import "./RecommendationCard.css";
function RecommendationCard({
  recommendationCardTitle,
  recommendation,
  currentPage,
  totalPages,
}) {
  const combinedGuidance = [
    recommendation?.guidance?.part1,
    recommendation?.guidance?.part2,
    recommendation?.guidance?.part3,
  ]
    .filter(Boolean) // Remove any undefined or null values
    .map((part, index) => `${index + 1}) ${part}`) // Add numbering to each part
    .join("<br>"); // Join parts with line breaks for HTML rendering

  return (
    <div className="card shadow-sm agent-improvement-recommendation-card-container">
      <div className="Agentcard-body">
        <h5 className="card-title agent-improvement-recommendation-card-title mb-4">
          {recommendationCardTitle} Improvement Recommendation {currentPage}/
          {totalPages}
        </h5>

        <div className="mb-4">
          <h6 className="agent-improvement-recommendation-labels">
            Opportunity:
          </h6>
          <p
            className="agent-improvement-recommendation-comments"
            dangerouslySetInnerHTML={{ __html: recommendation?.opportunity }}
          ></p>
        </div>

        <div className="mb-4">
          <h6 className="agent-improvement-recommendation-labels">
            Recommendation:
          </h6>
          <p className="agent-improvement-recommendation-comments">
           <span className="example">Example:{" "}</span>
            <span
              dangerouslySetInnerHTML={{
                __html: recommendation?.recommendation,
              }}
            ></span>
          </p>
        </div>

        <div className="mb-4">
          <h6 className="agent-improvement-recommendation-labels">Guidance:</h6>
          <p
            className="agent-improvement-recommendation-comments"
            dangerouslySetInnerHTML={{ __html: combinedGuidance }}
          ></p>
        </div>
      </div>
    </div>
  );
}

export default RecommendationCard;
